/*
    Chequea si luego del BASENAME_URL hay un subpath que sea un lenguaje ej: localhost:3000/incoming/en/
    Si lo hay setea el lenguaje acorde ese subpath sino setea el lenguaje segun la preferencia del navegador del usuario

*/
export const setLanguage = () => {
    const subPathLanguage = window.location.pathname.split('/')[2]

    if ((subPathLanguage && subPathLanguage === 'en') || subPathLanguage === 'es' || subPathLanguage === 'pt') {
        return subPathLanguage
    } else {
        const locale =
            (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage || 'en-US'

        // Extraemos los dos primeros caracteres del código de idioma
        const lang = locale.substr(0, 2)

        //Si el idioma no es Ingles, Español ni Portugues entonces el idioma por DEFAULT sera 'ES'
        const navigatorLanguage = lang !== 'es' && lang !== 'en' && lang !== 'pt' ? 'es' : lang
        return navigatorLanguage
    }
}

//Funcion para escribir los search de la url en base a las opciones seleccionadas
//Si no se pasan parametros servira para limpiar el search ya que devolver un string vacio
export const writeSearch = (destination, type_of_travel, type_of_experience) => {
    let search = ''

    if (destination) {
        search += `?destination=${encodeURIComponent(destination)}`
    }
    if (type_of_travel) {
        if (search) {
            search += `&type_of_travel=${encodeURIComponent(type_of_travel)}`
        } else {
            search += `?type_of_travel=${encodeURIComponent(type_of_travel)}`
        }
    }
    if (type_of_experience) {
        if (search) {
            search += `&type_of_experience=${encodeURIComponent(type_of_experience)}`
        } else {
            search += `?type_of_experience=${encodeURIComponent(type_of_experience)}`
        }
    }

    return search
}
/*
    Para las imagenes de banner del detalle de itinerario.
    Cheque la orientacion y el pixelRatio para saber cual imagen usar.
    Luego con esa informacion selecciona dentro de las imagenes que tiene el itinerario.
    Si no consigue nada devuelve un placeholder.
*/
export const chooseUrlByOrientationAndPixelRatio = (screenOrientation, devicePixelRatio, images) => {
    if (screenOrientation === 'portrait' && devicePixelRatio === 1) {
        //Si estamos en portrait y el devicePixelRatio es 1 entonces utilizamos portrait[0] si existe
        if (images.banner.portrait.length > 0) {
            return images.banner.portrait[0]
        } else {
            //Si estamos en portrait y el devicePixelRatio es 1 y no existen imagenes portrait
            //Entonces elegimos la landscape[0] si existe sino NULL (se usara placeholder)
            if (images.banner.landscape.length > 0) {
                return images.banner.landscape[0]
            } else {
                return 'placeholder_portrait'
            }
        }
    }
    if (screenOrientation === 'portrait' && devicePixelRatio > 1) {
        //Si estamos en portrait y el devicePixelRatio es mayor a 1 entonces utilizamos portrait[1] si existe
        if (images.banner.portrait.length === 2) {
            return images.banner.portrait[1]
        }
        //Si no existe portrait[1] entonces utilizamos portrait[0] si existe
        if (images.banner.portrait.length === 1) {
            return images.banner.portrait[0]
        }

        //Si no existen ni portrait[0] ni portrait[1] entonces elegimos la landscape[1] sino landscape[0]  sino NULL (se usara placeholder)
        if (images.banner.portrait.length === 0) {
            //Entonces elegimos la imagen [0] de landscape si existe sino NULL (se usara placeholder)
            if (images.banner.landscape.length === 2) {
                return images.banner.landscape[1]
            } else if (images.banner.landscape.length === 1) {
                return images.banner.landscape[0]
            } else {
                return 'placeholder_portrait'
            }
        }
    }
    if (screenOrientation === 'landscape' && devicePixelRatio === 1) {
        //Si estamos en landscape y el devicePixelRatio es 1 entonces utilizamos landscape[0] si existe
        if (images.banner.landscape.length > 0) {
            return images.banner.landscape[0]
        } else {
            //Si estamos en landscape y el devicePixelRatio es 1 y no existen imagenes landscape
            //Entonces elegimos la portrait[0] si existe sino NULL (se usara placeholder)
            if (images.banner.portrait.length > 0) {
                return images.banner.portrait[0]
            } else {
                return 'placeholder_landscape'
            }
        }
    }
    if (screenOrientation === 'landscape' && devicePixelRatio > 1) {
        //Si estamos en landscape y el devicePixelRatio es mayor a 1 entonces utilizamos landscape[1] si existe
        if (images.banner.landscape.length === 2) {
            return images.banner.landscape[1]
        }
        //Si no existe landscape[1] entonces utilizamos landscape[0] si existe
        if (images.banner.landscape.length === 1) {
            return images.banner.landscape[0]
        }

        //Si no existen ni landscape[0] ni landscape[1] entonces elegimos la portrait[0] si existe sino NULL (se usara placeholder)
        if (images.banner.landscape.length === 0) {
            //Entonces elegimos la portrait[1] si existe sino portrait[0] sino NULL (se usara placeholder)
            if (images.banner.portrait.length === 2) {
                return images.banner.portrait[1]
            } else if (images.banner.portrait.length === 1) {
                return images.banner.portrait[1]
            } else {
                return 'placeholder_landscape'
            }
        }
    }
}
/*
    Recibe el array de imagenes de destacadosHome y elije segun el pixel ratio
*/
export const chooseUrlByPixelRatio = (devicePixelRatio, image) => {
    if (devicePixelRatio < 1.2) {
        return image[0]
    }
    if (devicePixelRatio >= 1.2 && devicePixelRatio < 2.2) {
        if (image.length === 2) {
            return image[1]
        } else {
            return image[0]
        }
    }
    if (devicePixelRatio >= 2.2) {
        if (image.length === 3) {
            return image[2]
        }
        if (image.length === 2) {
            return image[1]
        }
        if (image.length === 1) {
            return image[0]
        }
    }
}

export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object
}

/*
const destination_options = []
destacadooos.forEach((destacado) => {
    destacado.destination.forEach((destination) => {
        if (!destination_options.includes(destination)) {
            destination_options.push(destination)
        }
    })
})
const type_of_travel_options = []
destacadooos.forEach((destacado) => {
    destacado.type_of_travel.forEach((type) => {
        if (!type_of_travel_options.includes(type)) {
            type_of_travel_options.push(type)
        }
    })
})
const type_of_experience_options = []
destacadooos.forEach((destacado) => {
    destacado.type_of_experience.forEach((type) => {
        if (!type_of_experience_options.includes(type)) {
            type_of_experience_options.push(type)
        }
    })
})

console.log({ destination_options })
console.log({ type_of_travel_options })
console.log({ type_of_experience_options })
*/
